<template>
  <div id="app_content" class="reserved">
    <div class="success">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h1>Ordine completato!</h1>

          </div>
          <div class="col-md-12">
            <a :href="url('/b2b/')" class="link-ret btn-my-primary black mt-5">Torna allo Shop</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
#app_content {
  .success {
    background-color: var(--greenb2b);
    padding: 50px 0;
    h1{
        font-size: 48px;
    }
  }
}
</style>
